import React, { Component } from "react";
// import ReactDOM from 'react-dom'
import { Box } from "reactjs-admin-lte";
import { Button, Breadcrumb, Modal, FormGroup, Form } from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import ReportCommissionMechanic from "./employee/ReportCommissionMechanic";
import ReportWorking from "./employee/ReportWorking";
import ReportKKCPurchaseOrderSummary from "./ReportKKCPurchaseOrderSummary";
import ReportProductBalance from "./stock/ReportProductBalance";
import ReportStockBalanceValue from "./stock/ReportStockBalanceValue";
import ReportProductTransactionImport from "./stock/ReportProductTransactionImport";
import ReportProductTransactionRequestPurchase from "./stock/ReportProductTransactionRequestPurchase";
import ReportStockCard from "./stock/ReportStockCard";
import ReportStockCardCost from "./stock/ReportStockCardCost";
import ReportStockFixingCar from "./stock/ReportStockFixingCar";
import ReportStockListInOut from "./stock/ReportStockListInOut";
import ReportPOReceivedProduct from "./po/ReportPOReceivedProduct";
import ReportPOStock from "./po/ReportPOStock";
import ReportSalesTax from "./finance/ReportSalesTax";
import ReportPostPayment from "./finance/ReportPostPayment";
import ReportAccountReceiable from "./finance/ReportAccountReceiable";
import ReportKKCAllYearProfit from "./ReportKKCAllYearProfit";
import ReportSummaryFixingWork from "./fixing/ReportSummaryFixingWork";
import ReportFixingRefixed from "./fixing/ReportFixingRefixed";
import ReportUnfinishedWork from "./fixing/ReportUnfinishedWork";
import ReportPostponeAppointment from "./fixing/ReportPostponeAppointment";
import ReportWaitingQuotation from "./fixing/ReportWaitingQuotation";
import ReportSummaryWork from "./analysis/ReportSummaryWork";
import ReportSummaryInsure from "./analysis/ReportSummaryInsure";
import ReportAnalysisClaimOfTheMonth from "./analysis/ReportAnalysisClaimOfTheMonth";
import ReportAnalysisInOutWork from "./analysis/ReportAnalysisInOutWork";
import ReportAnalysisWorkCustomCost from "./analysis/ReportAnalysisWorkCustomCost";
import ReportAnalysisDeliveryEfficiency from "./analysis/ReportAnalysisDeliveryEfficiency";
import ReportAnalysisWorkDebitCreditInOut from "./analysis/ReportAnalysisWorkDebitCreditInOut";
import ReportKKCIncome from "./ReportKKCIncome";
import ReportPickup from "./ReportPickup";
import ReportSummarySlip from "../hr/report/ReportSummarySlip";
import ReportSummaryOT from "../hr/report/ReportSummaryOT";
import ReportSummaryNormalAbsence from "../hr/report/ReportSummaryNormalAbsence";
import ReportSummaryDeductionAbsence from "../hr/report/ReportSummaryDeductionAbsence";
import ReportConsumablesMaterial from "./material/ReportConsumablesMaterial";
import ReportColor from "./material/ReportColor";
import ReportBalanceMaterial from "./material/ReportBalanceMaterial";
import ReportJobCostSheet from "./analysis/ReportJobCostSheet";
import ReportQuotationMovement from "./analysis/ReportQuotationMovement";
import ReportOutstandingIncomeSummary from "./analysis/ReportOutstandingIncomeSummary";
import ReportStockMixPaint from "./material/ReportStockMixPaint";
import ReportUsageVolumeTransactionRecord from "./material/ReportUsageVolumeTransactionRecord";
import ReportStockCardVolume from "./material/ReportStockCardVolume";
import ReportAnalysisBestJobcardProduct from "./statistics/ReportAnalysisBestJobcardProduct";
import ReportAnalysisBestPurchaseProduct from "./statistics/ReportAnalysisBestPurchaseProduct";
import ReportAnalysisBestPoShop from "./statistics/ReportAnalysisBestPoShop";
import ReportAnalysisBestJobcardService from "./statistics/ReportAnalysisBestJobcardService";
import ReportAnalysisBestJobcardBrand from "./statistics/ReportAnalysisBestJobcardBrand";
import ReportAnalysisBestJobcardInsurer from "./statistics/ReportAnalysisBestJobcardInsurer";
import ReportReceiptVoucherPage from "./ReportReceiptVoucherPage";
import ReportPaymentVoucherPage from "./ReportPaymentVoucherPage";
import ReportStore from "stores/ReportStore";
import { Checkbox } from "react-icheck";
import Select from "react-select";
import "./report.css";
var NotificationSystem = require("react-notification-system");
const employeeReportCategory = [
  {
    show: true,
    icon: "users",
    keyHead: 0,
    titleHead: "รายงานพนักงานและช่าง",
    title: "รายงานการปฏิบัติงานของออฟฟิศ",
    key: 0,
  },
  {
    show: true,
    icon: "users",
    keyHead: 0,
    titleHead: "รายงานพนักงานและช่าง",
    title: "รายงานการปฏิบัติงานของช่าง",
    key: 33,
  },
  {
    show: true,
    icon: "users",
    keyHead: 0,
    titleHead: "รายงานพนักงานและช่าง",
    title: "รายงานสรุปส่วนแบ่งผลการปฏิบัติงานของช่าง",
    key: 2,
  },
];
const dataAnalysisReportCategory = [
  {
    show: true,
    icon: "line-chart",
    keyHead: 1,
    titleHead: "รายงานวิเคราะห์ข้อมูล",
    title: "รายงานความเคลื่อนไหวการเสนอราคา",
    key: 4,
  },
  {
    show: true,
    icon: "line-chart",
    keyHead: 1,
    titleHead: "รายงานวิเคราะห์ข้อมูล",
    title: "รายงานสรุปรถเข้าออก",
    key: 5,
  },
  {
    show: true,
    icon: "line-chart",
    keyHead: 1,
    titleHead: "รายงานวิเคราะห์ข้อมูล",
    title: "รายงาน Job Cost Sheet (ต้นทุนด้านต่างๆ)",
    key: 6,
  },
  {
    show: true,
    icon: "line-chart",
    keyHead: 1,
    titleHead: "รายงานวิเคราะห์ข้อมูล",
    title: "รายงานสรุปยอดรายได้ค้างรับประกัน",
    key: 7,
  },
  {
    show: true,
    icon: "line-chart",
    keyHead: 1,
    titleHead: "รายงานวิเคราะห์ข้อมูล",
    title: "รายงานสรุปยอดรายได้ประกัน (รายเดือน)",
    key: 43,
  },
  {
    show: true,
    icon: "line-chart",
    keyHead: 1,
    titleHead: "รายงานวิเคราะห์ข้อมูล",
    title: "รายงานสรุปค่าใช้จ่ายของรถลูกค้าแต่ละคัน",
    key: 32,
  },
  {
    show: true,
    icon: "line-chart",
    keyHead: 1,
    titleHead: "รายงานวิเคราะห์ข้อมูล",
    title: "รายงานรถแจ้งเคลมประจำเดือน",
    key: 57,
  },
  {
    show: true,
    icon: "line-chart",
    keyHead: 1,
    titleHead: "รายงานวิเคราะห์ข้อมูล",
    title: "รายงานรถเข้า-ออก",
    key: 58,
  },
  {
    show: true,
    icon: "line-chart",
    keyHead: 1,
    titleHead: "รายงานวิเคราะห์ข้อมูล",
    title: "รายงานต้นทุน",
    key: 59,
  },
  {
    show: true,
    icon: "line-chart",
    keyHead: 1,
    titleHead: "รายงานวิเคราะห์ข้อมูล",
    title: "รายงานประสิทธิภาพในการส่งมอบรถ",
    key: 60,
  },
  {
    show: true,
    icon: "line-chart",
    keyHead: 1,
    titleHead: "รายงานวิเคราะห์ข้อมูล",
    title: "รายงานสรุปงานซ่อมรถเข้า-ออก เงินสด/ประกัน",
    key: 63,
  },
];
const workReportCategory = [
  {
    show: true,
    icon: "wrench",
    keyHead: 2,
    titleHead: "รายงานงานซ่อม",
    title: "รายงานสรุประยะเวลางานซ่อมของรถแต่ละคัน",
    key: 42,
  },
  {
    show: true,
    icon: "wrench",
    keyHead: 2,
    titleHead: "รายงานงานซ่อม",
    title: "รายงานสรุปงานซ่อมค้างปิด",
    key: 8,
  },
  {
    show: true,
    icon: "wrench",
    keyHead: 2,
    titleHead: "รายงานงานซ่อม",
    title: "รายงานสร้างงานซ่อมแก้ไข",
    key: 9,
  },
  {
    show: true,
    icon: "wrench",
    keyHead: 2,
    titleHead: "รายงานงานซ่อม",
    title: "รายงานเลื่อนนัด",
    key: 10,
  },
  {
    show: true,
    icon: "wrench",
    keyHead: 2,
    titleHead: "รายงานงานซ่อม",
    title: "รายงานงานซ่อมรอส่งเรื่อง",
    key: 29,
  },
];
const materialColorReportCategory = [
  {
    show: true,
    icon: "industry",
    keyHead: 3,
    titleHead: "รายงานการใช้วัสดุสิ้นเปลืองและสี",
    title: "รายงานการเบิกใช้วัสดุสิ้นเปลือง",
    key: 11,
  },
  {
    show: true,
    icon: "industry",
    keyHead: 3,
    titleHead: "รายงานการใช้วัสดุสิ้นเปลืองและสี",
    title: "รายงานการใช้สีประจำเดือน",
    key: 12,
  },
  {
    show: true,
    icon: "industry",
    keyHead: 3,
    titleHead: "รายงานการใช้วัสดุสิ้นเปลืองและสี",
    title: "รายงานของเหลวและสีคงเหลือ",
    key: 13,
  },
  {
    show: true,
    icon: "industry",
    keyHead: 3,
    titleHead: "รายงานการใช้วัสดุสิ้นเปลืองและสี",
    title: "รายงานการเบิกแม่สีผสม",
    key: 14,
  },
  {
    show: true,
    icon: "industry",
    keyHead: 3,
    titleHead: "รายงานการใช้วัสดุสิ้นเปลืองและสี",
    title: "รายงานการเบิกของเหลว (ชั่งตวง)",
    key: 39,
  },
];
const stockReportCategory = [
  {
    show: true,
    icon: "industry",
    keyHead: 4,
    titleHead: "รายงานคลัง",
    title: "รายงานปรับสต็อก",
    key: 15,
  },
  {
    show: true,
    icon: "industry",
    keyHead: 4,
    titleHead: "รายงานคลัง",
    title: "รายงานสรุปยอดขอสั่งซื้อ",
    key: 31,
  },
  {
    show: true,
    icon: "industry",
    keyHead: 4,
    titleHead: "รายงานคลัง",
    title: "รายงานสรุปยอดจัดซื้อ",
    key: 16,
  },
  {
    show: true,
    icon: "industry",
    keyHead: 4,
    titleHead: "รายงานคลัง",
    title: "รายงานสรุปยอดรับเข้าออก",
    key: 18,
  },
  {
    show: true,
    icon: "industry",
    keyHead: 4,
    titleHead: "รายงานคลัง",
    title: "รายงานสรุปรับวัสดุสิ้นเปลืองจากใบสั่งซื้อ",
    key: 21,
  },
  {
    show: true,
    icon: "industry",
    keyHead: 4,
    titleHead: "รายงานคลัง",
    title: "รายงานซ่อมรถเบิกคลัง",
    key: 54,
  },
  {
    show: true,
    icon: "industry",
    keyHead: 4,
    titleHead: "รายงานคลัง",
    title: "รายงานช่างเบิกของต่อเดือน",
    key: 34,
  },
  {
    show: true,
    icon: "industry",
    keyHead: 4,
    titleHead: "รายงานคลัง",
    title: "รายงานสต็อกมูลค่าคงเหลือ",
    key: 50,
  },
  {
    show: true,
    icon: "industry",
    keyHead: 4,
    titleHead: "รายงานคลัง",
    title: "รายงานความเคลื่อนไหวของสต็อก (Stock Card)",
    key: 51,
  },
  {
    show: true,
    icon: "industry",
    keyHead: 4,
    titleHead: "รายงานคลัง",
    title: "รายงานความเคลื่อนไหวต้นทุนสต็อก (Stock Card Cost)",
    key: 53,
  },
  {
    show: true,
    icon: "industry",
    keyHead: 4,
    titleHead: "รายงานคลัง",
    title: "รายงานซื้อ-ซ่อม/เข้า-ออก-คงเหลือ ตัดรอบตามวันที่",
    key: 62,
  },
];
const financeReportCategory = [
  {
    show: true,
    icon: "money",
    keyHead: 5,
    titleHead: "รายงานการเงิน",
    title: "รายงานงวดตั้งเบิกค้างรับ",
    key: 22,
  },
  {
    show: true,
    icon: "money",
    keyHead: 5,
    titleHead: "รายงานการเงิน",
    title: "รายงานภาษีขาย",
    key: 23,
  },
  {
    show: true,
    icon: "money",
    keyHead: 5,
    titleHead: "รายงานการเงิน",
    title: "รายงานสำคัญรับ",
    key: 55,
  },
  {
    show: true,
    icon: "money",
    keyHead: 5,
    titleHead: "รายงานการเงิน",
    title: "รายงานสำคัญจ่าย",
    key: 56,
  },
  {
    show: true,
    icon: "money",
    keyHead: 5,
    titleHead: "รายงานการเงิน",
    title: "รายงานสรุปรายรับรายจ่ายประจำปี",
    key: 30,
  },
  {
    show: true,
    icon: "money",
    keyHead: 5,
    titleHead: "รายงานการเงิน",
    title: "รายงานสรุปยอดรับเงินแล้ว",
    key: 41,
  },
];
const poReportCategory = [
  {
    show: true,
    icon: "shopping-cart",
    keyHead: 6,
    titleHead: "รายงานสั่งซื้อ (PO)",
    title: "รายงานสรุปยอดสั่งซื้อวัสดุ - อะไหล่ (รวม)",
    key: 24,
  },
  {
    show: true,
    icon: "shopping-cart",
    keyHead: 6,
    titleHead: "รายงานสั่งซื้อ (PO)",
    title: "รายงานสรุปยอดสั่งซื้อวัสดุ - อะไหล่ (เครดิต 45 วัน)",
    key: 25,
  },
  {
    show: true,
    icon: "shopping-cart",
    keyHead: 6,
    titleHead: "รายงานสั่งซื้อ (PO)",
    title: "รายงานสรุปยอดสั่งซื้อวัสดุ - อะไหล่ (เครดิต 60 วัน)",
    key: 26,
  },
  {
    show: true,
    icon: "shopping-cart",
    keyHead: 6,
    titleHead: "รายงานสั่งซื้อ (PO)",
    title: "รายงานสั่งซื้อวัสดุ - อะไหล่ (แจงรายละเอียด)",
    key: 40,
  },
  {
    show: true,
    icon: "shopping-cart",
    keyHead: 6,
    titleHead: "รายงานสั่งซื้อ (PO)",
    title: "รายงานรับอะไหล่จากใบสั่งซื้อ",
    key: 20,
  },
  {
    show: true,
    icon: "shopping-cart",
    keyHead: 6,
    titleHead: "รายงานสั่งซื้อ (PO)",
    title: "รายงานเบิกอะไหล่จากใบสั่งซื้อ",
    key: 27,
  },
  {
    show: true,
    icon: "shopping-cart",
    keyHead: 6,
    titleHead: "รายงานสั่งซื้อ (PO)",
    title: "รายงานคืนอะไหล่จากใบสั่งซื้อ",
    key: 28,
  },
  {
    show: true,
    icon: "shopping-cart",
    keyHead: 6,
    titleHead: "รายงานสั่งซื้อ (PO)",
    title: "รายงานนำอะไหล่เข้าคลังจากใบสั่งซื้อ",
    key: 100,
  },
  {
    show: true,
    icon: "shopping-cart",
    keyHead: 6,
    titleHead: "รายงานสั่งซื้อ (PO)",
    title: "รายงาน Stock อะไหล่จาก PO ตัดเข้ารถยนต์",
    key: 101,
  },
];
const hrReportCategory = [
  {
    show: true,
    icon: "user",
    keyHead: 7,
    titleHead: "รายงานฝ่ายบุคคล",
    title: "รายงานค่าแรง",
    key: 35,
  },
  {
    show: true,
    icon: "user",
    keyHead: 7,
    titleHead: "รายงานฝ่ายบุคคล",
    title: "รายงาน OT รวม",
    key: 36,
  },
  {
    show: true,
    icon: "user",
    keyHead: 7,
    titleHead: "รายงานฝ่ายบุคคล",
    title: "รายงานลางานทั่วไป",
    key: 37,
  },
  {
    show: true,
    icon: "user",
    keyHead: 7,
    titleHead: "รายงานฝ่ายบุคคล",
    title: "รายงานลางานหักเงินเดือน",
    key: 38,
  },
];
const statisticsSummaryReportCategory = [
  {
    show: true,
    icon: "line-chart",
    keyHead: 8,
    titleHead: "รายงานสรุปสถิติ",
    title: "รายงานสรุปอะไหล่งานซ่อมยอดนิยม",
    key: 44,
  },
  {
    show: true,
    icon: "line-chart",
    keyHead: 8,
    titleHead: "รายงานสรุปสถิติ",
    title: "รายงานสรุปอะไหล่สั่งซื้อยอดนิยม",
    key: 45,
  },
  {
    show: true,
    icon: "line-chart",
    keyHead: 8,
    titleHead: "รายงานสรุปสถิติ",
    title: "รายงานสรุปร้านสั่งซื้อยอดนิยม",
    key: 48,
  },
  {
    show: true,
    icon: "line-chart",
    keyHead: 8,
    titleHead: "รายงานสรุปสถิติ",
    title: "รายงานสรุปบริการยอดนิยม",
    key: 46,
  },
  {
    show: true,
    icon: "line-chart",
    keyHead: 8,
    titleHead: "รายงานสรุปสถิติ",
    title: "รายงานสรุปซ่อมรถยี่ห้อยอดนิยม",
    key: 47,
  },
  {
    show: true,
    icon: "line-chart",
    keyHead: 8,
    titleHead: "รายงานสรุปสถิติ",
    title: "รายงานสรุปซ่อมประกันยอดนิยม",
    key: 49,
  },
];
class ReportCategoryPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      eventKey: undefined,
      subEventKey: undefined,
      titleMenu: "",
      titleIcon: "",
      titleKey: undefined,
      show: false,
      workReportCategory: workReportCategory,
      poReportCategory: poReportCategory,
      stockReportCategory: stockReportCategory,
      materialColorReportCategory: materialColorReportCategory,
      dataAnalysisReportCategory: dataAnalysisReportCategory,
      hrReportCategory: hrReportCategory,
      financeReportCategory: financeReportCategory,
      employeeReportCategory: employeeReportCategory,
      statisticsSummaryReportCategory: statisticsSummaryReportCategory,
      checkWorkReportCategory: JSON.parse(JSON.stringify(workReportCategory)),
      checkPoReportCategory: JSON.parse(JSON.stringify(poReportCategory)),
      checkStockReportCategory: JSON.parse(JSON.stringify(stockReportCategory)),
      checkMaterialColorReportCategory: JSON.parse(
        JSON.stringify(materialColorReportCategory)
      ),
      checkDataAnalysisReportCategory: JSON.parse(
        JSON.stringify(dataAnalysisReportCategory)
      ),
      checkHrReportCategory: JSON.parse(JSON.stringify(hrReportCategory)),
      checkFinanceReportCategory: JSON.parse(
        JSON.stringify(financeReportCategory)
      ),
      checkEmployeeReportCategory: JSON.parse(
        JSON.stringify(employeeReportCategory)
      ),
      checkStatisticsSummaryReportCategory: JSON.parse(
        JSON.stringify(statisticsSummaryReportCategory)
      ),
      checkAll: {
        workReportCategory: false,
        poReportCategory: false,
        stockReportCategory: false,
        materialColorReportCategory: false,
        dataAnalysisReportCategory: false,
        hrReportCategory: false,
        financeReportCategory: false,
        employeeReportCategory: false,
        statisticsSummaryReportCategory: false,
      },
      roles: [],
      role: "",
    };
    this._box = new Array(9).fill("");
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    if (!this.props.callOut) {
      this.loadData();
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.callOut && newProps.show && newProps.show !== this.props.show)
      this.loadData();
  }

  //   setItemlistConfig(field,default_itemlist,itemlist) {
  //     let {checkAll} = this.state
  //     let check = true
  //     default_itemlist = itemlist.map((item,index)=>{
  //         if (!item.show)
  //             check = false

  //         default_itemlist[index].show = item.show
  //         return default_itemlist[index]
  //     })
  //     checkAll[field] = check
  //     this.setState({checkAll:checkAll})
  //     return default_itemlist
  //   }

  setItemlistConfig(field, default_itemlist, itemlist) {
    let { checkAll } = this.state;
    let check = true;
    let new_itemlist = [];
    default_itemlist.forEach((item, index) => {
      let findIndex = itemlist.findIndex((x) => x.key === item.key);
      if (findIndex !== -1) {
        if (!itemlist[findIndex].show) check = false;
        item.show = itemlist[findIndex].show;
        new_itemlist.push(item);
      } else {
        check = false;
        item.show = false;
        new_itemlist.push(item);
      }
    });
    checkAll[field] = check;
    this.setState({ checkAll: checkAll });
    return new_itemlist;
  }

  setItemlistAfterLoad(result, complete) {
    let {
      checkAll,
      workReportCategory,
      stockReportCategory,
      financeReportCategory,
      poReportCategory,
      materialColorReportCategory,
      dataAnalysisReportCategory,
      hrReportCategory,
      employeeReportCategory,
      statisticsSummaryReportCategory,
    } = this.state;
    if (result.data.workReportCategory.length === 0) {
      workReportCategory = Object.assign(
        workReportCategory,
        result.data.workReportCategory
      );
      checkAll.workReportCategory = true;
    } else
      workReportCategory = this.setItemlistConfig(
        "workReportCategory",
        workReportCategory,
        result.data.workReportCategory
      );

    if (result.data.stockReportCategory.length === 0) {
      stockReportCategory = Object.assign(
        stockReportCategory,
        result.data.stockReportCategory
      );
      checkAll.stockReportCategory = true;
    } else
      stockReportCategory = this.setItemlistConfig(
        "stockReportCategory",
        stockReportCategory,
        result.data.stockReportCategory
      );

    if (result.data.financeReportCategory.length === 0) {
      financeReportCategory = Object.assign(
        financeReportCategory,
        result.data.financeReportCategory
      );
      checkAll.financeReportCategory = true;
    } else
      financeReportCategory = this.setItemlistConfig(
        "financeReportCategory",
        financeReportCategory,
        result.data.financeReportCategory
      );

    if (result.data.poReportCategory.length === 0) {
      poReportCategory = Object.assign(
        poReportCategory,
        result.data.poReportCategory
      );
      checkAll.poReportCategory = true;
    } else
      poReportCategory = this.setItemlistConfig(
        "poReportCategory",
        poReportCategory,
        result.data.poReportCategory
      );

    if (
      typeof result.data.materialColorReportCategory === "undefined" ||
      result.data.materialColorReportCategory.length === 0
    ) {
      materialColorReportCategory = Object.assign(
        materialColorReportCategory,
        result.data.materialColorReportCategory
      );
      checkAll.materialColorReportCategory = true;
    } else
      materialColorReportCategory = this.setItemlistConfig(
        "materialColorReportCategory",
        materialColorReportCategory,
        result.data.materialColorReportCategory
      );

    if (result.data.dataAnalysisReportCategory.length === 0) {
      dataAnalysisReportCategory = Object.assign(
        dataAnalysisReportCategory,
        result.data.dataAnalysisReportCategory
      );
      checkAll.dataAnalysisReportCategory = true;
    } else
      dataAnalysisReportCategory = this.setItemlistConfig(
        "dataAnalysisReportCategory",
        dataAnalysisReportCategory,
        result.data.dataAnalysisReportCategory
      );

    if (result.data.hrReportCategory.length === 0) {
      hrReportCategory = Object.assign(
        hrReportCategory,
        result.data.hrReportCategory
      );
      checkAll.hrReportCategory = true;
    } else
      hrReportCategory = this.setItemlistConfig(
        "hrReportCategory",
        hrReportCategory,
        result.data.hrReportCategory
      );

    if (
      typeof result.data.employeeReportCategory === "undefined" ||
      result.data.employeeReportCategory.length === 0
    ) {
      employeeReportCategory = Object.assign(
        employeeReportCategory,
        result.data.employeeReportCategory
      );
      checkAll.employeeReportCategory = true;
    } else
      employeeReportCategory = this.setItemlistConfig(
        "employeeReportCategory",
        employeeReportCategory,
        result.data.employeeReportCategory
      );

    if (
      typeof result.data.statisticsSummaryReportCategory === "undefined" ||
      result.data.statisticsSummaryReportCategory.length === 0
    ) {
      statisticsSummaryReportCategory = Object.assign(
        statisticsSummaryReportCategory,
        result.data.statisticsSummaryReportCategory
      );
      checkAll.statisticsSummaryReportCategory = true;
    } else
      statisticsSummaryReportCategory = this.setItemlistConfig(
        "statisticsSummaryReportCategory",
        statisticsSummaryReportCategory,
        result.data.statisticsSummaryReportCategory
      );

    this.setState(
      {
        checkAll: checkAll,
        workReportCategory: workReportCategory,
        stockReportCategory: stockReportCategory,
        financeReportCategory: financeReportCategory,
        poReportCategory: poReportCategory,
        materialColorReportCategory: materialColorReportCategory,
        dataAnalysisReportCategory: dataAnalysisReportCategory,
        hrReportCategory: hrReportCategory,
        statisticsSummaryReportCategory: statisticsSummaryReportCategory,
        employeeReportCategory: employeeReportCategory,
      },
      () => {
        if (complete !== undefined) complete();
      }
    );
  }

  loadData() {
    this.setState({ loading: true });
    ReportStore.loadPermCategoryReport((result) => {
      this.setItemlistAfterLoad(result, () => {
        this.setState({ loading: false });
      });
    });
  }

  onViewPoClick(item) {
    this.setState(
      {
        eventKey: item.key,
        titleMenu: item.titleHead,
        titleIcon: item.icon,
        titleKey: item.keyHead,
      },
      () => {
        this.refs.focus.focus();
      }
    );
  }

  onUpdateEventKey(key) {
    this.setState({ subEventKey: key });
  }

  onRootMenuClick() {
    let { subEventKey, eventKey } = this.state;
    if (subEventKey !== undefined) {
      if (eventKey === 0)
        this.refs.reportWorkingOffice.onTableDetailCloseClick();
      else if (eventKey === 5)
        this.refs.reportSummaryWork.onTableDetailCloseClick();
      else if (eventKey === 6)
        this.refs.reportJobCostSheet.onTableDetailCloseClick();
      else if (eventKey === 7)
        this.refs.reportOutstandingIncomeSummary.onTableDetailCloseClick();
      else if (eventKey === 8)
        this.refs.reportUnfinishedWork.onTableDetailCloseClick();
      else if (eventKey === 12) this.refs.reportColor.onTableDetailCloseClick();
      else if (eventKey === 22)
        this.refs.reportAccountReceiable.onTableDetailCloseClick();
      else if (eventKey === 33)
        this.refs.reportWorkingMechanic.onTableDetailCloseClick();
      else if (eventKey === 34)
        this.refs.reportPickup.onTableDetailCloseClick();

      this.setState({
        eventKey: undefined,
        subEventKey: undefined,
        titleMenu: "",
        titleIcon: "",
        titleKey: undefined,
      });
    } else {
      this.setState({
        eventKey: undefined,
        titleMenu: "",
        titleIcon: "",
        titleKey: undefined,
      });
    }
  }

  onSubRootMenuClick(titleKey) {
    this.onRootMenuClick();
    setTimeout(() => {
      this._box[titleKey].scrollIntoView();
    }, 100);
  }

  onMenuClick(item) {
    let { subEventKey, eventKey } = this.state;
    if (subEventKey !== undefined) {
      this.setState({ subEventKey: undefined }, () => {
        if (eventKey === 0)
          this.refs.reportWorkingOffice.onTableDetailCloseClick();
        else if (eventKey === 5)
          this.refs.reportSummaryWork.onTableDetailCloseClick();
        else if (eventKey === 6)
          this.refs.reportJobCostSheet.onTableDetailCloseClick();
        else if (eventKey === 7)
          this.refs.reportOutstandingIncomeSummary.onTableDetailCloseClick();
        else if (eventKey === 8)
          this.refs.reportUnfinishedWork.onTableDetailCloseClick();
        else if (eventKey === 12)
          this.refs.reportColor.onTableDetailCloseClick();
        else if (eventKey === 22)
          this.refs.reportAccountReceiable.onTableDetailCloseClick();
        else if (eventKey === 33)
          this.refs.reportWorkingMechanic.onTableDetailCloseClick();
        else if (eventKey === 34)
          this.refs.reportPickup.onTableDetailCloseClick();
      });
    } else {
      this.setState({ eventKey: item.key });
    }
  }

  onLoadConfig(complete) {
    let { roles, role } = this.state;
    this.setState({ loading: true });
    ReportStore.loadConfigCategoryReport(role, (result) => {
      roles = result.roles.map((item, index) => {
        return { label: item.name, value: item.bf_role_id };
      });
      this.setItemlistAfterLoad(result, () => {
        let {
          checkWorkReportCategory,
          checkStockReportCategory,
          checkFinanceReportCategory,
          checkPoReportCategory,
          checkMaterialColorReportCategory,
          checkDataAnalysisReportCategory,
          checkHrReportCategory,
          checkEmployeeReportCategory,
          checkStatisticsSummaryReportCategory,
        } = this.state;
        (checkWorkReportCategory = JSON.parse(
          JSON.stringify(this.state.workReportCategory)
        )),
          (checkPoReportCategory = JSON.parse(
            JSON.stringify(this.state.poReportCategory)
          )),
          (checkStockReportCategory = JSON.parse(
            JSON.stringify(this.state.stockReportCategory)
          )),
          (checkMaterialColorReportCategory = JSON.parse(
            JSON.stringify(this.state.materialColorReportCategory)
          )),
          (checkDataAnalysisReportCategory = JSON.parse(
            JSON.stringify(this.state.dataAnalysisReportCategory)
          )),
          (checkHrReportCategory = JSON.parse(
            JSON.stringify(this.state.hrReportCategory)
          )),
          (checkFinanceReportCategory = JSON.parse(
            JSON.stringify(this.state.financeReportCategory)
          )),
          (checkEmployeeReportCategory = JSON.parse(
            JSON.stringify(this.state.employeeReportCategory)
          )),
          (checkStatisticsSummaryReportCategory = JSON.parse(
            JSON.stringify(this.state.statisticsSummaryReportCategory)
          ));
        this.setState(
          {
            loading: false,
            checkWorkReportCategory: checkWorkReportCategory,
            checkPoReportCategory: checkPoReportCategory,
            checkStockReportCategory: checkStockReportCategory,
            checkMaterialColorReportCategory: checkMaterialColorReportCategory,
            checkDataAnalysisReportCategory: checkDataAnalysisReportCategory,
            checkHrReportCategory: checkHrReportCategory,
            checkFinanceReportCategory: checkFinanceReportCategory,
            checkEmployeeReportCategory: checkEmployeeReportCategory,
            checkStatisticsSummaryReportCategory:
              checkStatisticsSummaryReportCategory,
            roles: roles,
          },
          () => {
            if (complete !== undefined) complete();
          }
        );
      });
    });
  }

  onSettingOpen() {
    // let {checkWorkReportCategory,checkStockReportCategory,checkFinanceReportCategory,checkPoReportCategory,checkMaterialColorReportCategory,checkDataAnalysisReportCategory,checkHrReportCategory,checkEmployeeReportCategory,checkStatisticsSummaryReportCategory} = this.state
    // checkWorkReportCategory = JSON.parse(JSON.stringify(this.state.workReportCategory)),
    // checkPoReportCategory = JSON.parse(JSON.stringify(this.state.poReportCategory)),
    // checkStockReportCategory = JSON.parse(JSON.stringify(this.state.stockReportCategory)),
    // checkMaterialColorReportCategory = JSON.parse(JSON.stringify(this.state.materialColorReportCategory)),
    // checkDataAnalysisReportCategory = JSON.parse(JSON.stringify(this.state.dataAnalysisReportCategory)),
    // checkHrReportCategory = JSON.parse(JSON.stringify(this.state.hrReportCategory)),
    // checkFinanceReportCategory = JSON.parse(JSON.stringify(this.state.financeReportCategory)),
    // checkEmployeeReportCategory = JSON.parse(JSON.stringify(this.state.employeeReportCategory)),
    // checkStatisticsSummaryReportCategory = JSON.parse(JSON.stringify(this.state.statisticsSummaryReportCategory))
    // this.setState({show:true,checkWorkReportCategory:checkWorkReportCategory,checkPoReportCategory:checkPoReportCategory,
    //     checkStockReportCategory:checkStockReportCategory,checkMaterialColorReportCategory:checkMaterialColorReportCategory,
    //     checkDataAnalysisReportCategory:checkDataAnalysisReportCategory,checkHrReportCategory:checkHrReportCategory,
    //     checkFinanceReportCategory:checkFinanceReportCategory,checkEmployeeReportCategory:checkEmployeeReportCategory,
    //     checkStatisticsSummaryReportCategory:checkStatisticsSummaryReportCategory
    // })

    this.onLoadConfig(() => {
      this.setState({ show: true });
    });
  }

  onHide() {
    this.setState({ show: false, role: "" });
  }

  onSetPost(itemlist) {
    let newItemlist = [];
    newItemlist = itemlist.map((item, index) => {
      return { show: item.show, key: item.key };
    });
    return newItemlist;
  }

  onSaveClick() {
    let {
      role,
      checkWorkReportCategory,
      checkStockReportCategory,
      checkFinanceReportCategory,
      checkPoReportCategory,
      checkDataAnalysisReportCategory,
      checkHrReportCategory,
      checkMaterialColorReportCategory,
      checkEmployeeReportCategory,
      checkStatisticsSummaryReportCategory,
    } = this.state;
    let postData = {
      workReportCategory: this.onSetPost(checkWorkReportCategory),
      poReportCategory: this.onSetPost(checkPoReportCategory),
      stockReportCategory: this.onSetPost(checkStockReportCategory),
      materialColorReportCategory: this.onSetPost(
        checkMaterialColorReportCategory
      ),
      dataAnalysisReportCategory: this.onSetPost(
        checkDataAnalysisReportCategory
      ),
      hrReportCategory: this.onSetPost(checkHrReportCategory),
      financeReportCategory: this.onSetPost(checkFinanceReportCategory),
      employeeReportCategory: this.onSetPost(checkEmployeeReportCategory),
      statisticsSummaryReportCategory: this.onSetPost(
        checkStatisticsSummaryReportCategory
      ),
      // workReportCategory:[],
      // poReportCategory:[],
      // stockReportCategory:[],
      // materialColorReportCategory:[],
      // dataAnalysisReportCategory:[],
      // hrReportCategory:[],
      // financeReportCategory:[],
      // employeeReportCategory:[],
      // statisticsSummaryReportCategory:[],
    };
    ReportStore.saveConfigCategoryReport(
      role,
      postData,
      (result) => {
        if (result.status === "OK") {
          this._notificationSystem.addNotification({
            title: "แจ้งเตือน",
            message: "บันทึกการตั้งค่าสำเร็จ",
            level: "info",
            position: "tc",
          });
          // this.setState({show:false,workReportCategory:JSON.parse(JSON.stringify(checkWorkReportCategory)),
          //     stockReportCategory:JSON.parse(JSON.stringify(checkStockReportCategory)),
          //     financeReportCategory:JSON.parse(JSON.stringify(checkFinanceReportCategory)),
          //     poReportCategory:JSON.parse(JSON.stringify(checkPoReportCategory)),
          //     materialColorReportCategory:JSON.parse(JSON.stringify(checkMaterialColorReportCategory)),
          //     dataAnalysisReportCategory:JSON.parse(JSON.stringify(checkDataAnalysisReportCategory)),
          //     hrReportCategory:JSON.parse(JSON.stringify(checkHrReportCategory)),
          //     employeeReportCategory:JSON.parse(JSON.stringify(checkEmployeeReportCategory)),
          //     statisticsSummaryReportCategory:JSON.parse(JSON.stringify(checkStatisticsSummaryReportCategory)),
          // })
          this.onHide();
          this.loadData();
        }
      },
      () => {
        this._notificationSystem.addNotification({
          title: "แจ้งเตือน",
          message: "ไม่สามารถบันทึกการตั้งค่าได้ กรุณาลองอีกครั้ง",
          level: "error",
          position: "tc",
        });
        this.onHide();
      }
    );
  }

  onReportAllClick(data, field, status) {
    let { checkAll } = this.state;
    checkAll[field] = status;
    this.setState({ checkAll: checkAll }, () => {
      data.forEach((item, index) => {
        this.onReportClick(data, index, status);
      });
    });
  }

  onReportClick(data, index, status) {
    let {
      checkAll,
      checkWorkReportCategory,
      checkStockReportCategory,
      checkFinanceReportCategory,
      checkPoReportCategory,
      checkDataAnalysisReportCategory,
      checkHrReportCategory,
      checkMaterialColorReportCategory,
      checkEmployeeReportCategory,
      checkStatisticsSummaryReportCategory,
    } = this.state;
    if (data[index].keyHead === 2) {
      checkWorkReportCategory[index].show = status;
      if (!status) checkAll.workReportCategory = false;
      else {
        let check = checkWorkReportCategory.findIndex((x) => x.show === false);
        if (check === -1) checkAll.workReportCategory = true;
        else checkAll.workReportCategory = false;
      }
      this.setState({
        checkWorkReportCategory: checkWorkReportCategory,
        checkAll: checkAll,
      });
    } else if (data[index].keyHead === 6) {
      checkPoReportCategory[index].show = status;
      if (!status) checkAll.poReportCategory = false;
      else {
        let check = checkPoReportCategory.findIndex((x) => x.show === false);
        if (check === -1) checkAll.poReportCategory = true;
        else checkAll.poReportCategory = false;
      }
      this.setState({
        checkPoReportCategory: checkPoReportCategory,
        checkAll: checkAll,
      });
    } else if (data[index].keyHead === 4) {
      checkStockReportCategory[index].show = status;
      if (!status) checkAll.stockReportCategory = false;
      else {
        let check = checkStockReportCategory.findIndex((x) => x.show === false);
        if (check === -1) checkAll.stockReportCategory = true;
        else checkAll.stockReportCategory = false;
      }
      this.setState({
        checkStockReportCategory: checkStockReportCategory,
        checkAll: checkAll,
      });
    } else if (data[index].keyHead === 3) {
      checkMaterialColorReportCategory[index].show = status;
      if (!status) checkAll.materialColorReportCategory = false;
      else {
        let check = checkMaterialColorReportCategory.findIndex(
          (x) => x.show === false
        );
        if (check === -1) checkAll.materialColorReportCategory = true;
        else checkAll.materialColorReportCategory = false;
      }
      this.setState({
        checkMaterialColorReportCategory: checkMaterialColorReportCategory,
        checkAll: checkAll,
      });
    } else if (data[index].keyHead === 1) {
      checkDataAnalysisReportCategory[index].show = status;
      if (!status) checkAll.dataAnalysisReportCategory = false;
      else {
        let check = checkDataAnalysisReportCategory.findIndex(
          (x) => x.show === false
        );
        if (check === -1) checkAll.dataAnalysisReportCategory = true;
        else checkAll.dataAnalysisReportCategory = false;
      }
      this.setState({
        checkDataAnalysisReportCategory: checkDataAnalysisReportCategory,
        checkAll: checkAll,
      });
    } else if (data[index].keyHead === 7) {
      checkHrReportCategory[index].show = status;
      if (!status) checkAll.hrReportCategory = false;
      else {
        let check = checkHrReportCategory.findIndex((x) => x.show === false);
        if (check === -1) checkAll.hrReportCategory = true;
        else checkAll.hrReportCategory = false;
      }
      this.setState({
        checkHrReportCategory: checkHrReportCategory,
        checkAll: checkAll,
      });
    } else if (data[index].keyHead === 5) {
      checkFinanceReportCategory[index].show = status;
      if (!status) checkAll.financeReportCategory = false;
      else {
        let check = checkFinanceReportCategory.findIndex(
          (x) => x.show === false
        );
        if (check === -1) checkAll.financeReportCategory = true;
        else checkAll.financeReportCategory = false;
      }
      this.setState({
        checkFinanceReportCategory: checkFinanceReportCategory,
        checkAll: checkAll,
      });
    } else if (data[index].keyHead === 0) {
      checkEmployeeReportCategory[index].show = status;
      if (!status) checkAll.employeeReportCategory = false;
      else {
        let check = checkEmployeeReportCategory.findIndex(
          (x) => x.show === false
        );
        if (check === -1) checkAll.employeeReportCategory = true;
        else checkAll.employeeReportCategory = false;
      }
      this.setState({
        checkEmployeeReportCategory: checkEmployeeReportCategory,
        checkAll: checkAll,
      });
    } else if (data[index].keyHead === 8) {
      checkStatisticsSummaryReportCategory[index].show = status;
      if (!status) checkAll.statisticsSummaryReportCategory = false;
      else {
        let check = checkStatisticsSummaryReportCategory.findIndex(
          (x) => x.show === false
        );
        if (check === -1) checkAll.statisticsSummaryReportCategory = true;
        else checkAll.statisticsSummaryReportCategory = false;
      }
      this.setState({
        checkStatisticsSummaryReportCategory:
          checkStatisticsSummaryReportCategory,
        checkAll: checkAll,
      });
    }
  }

  onRoleChange(e) {
    if (e !== null) {
      this.setState({ role: e.value }, () => {
        this.onLoadConfig();
      });
    } else {
      this.setState({ role: "" }, () => {
        this.onLoadConfig();
      });
    }
  }

  renderRowData(data, isModal) {
    const success = [
      2, 15, 18, 24, 25, 26, 20, 40, 27, 28, 100, 101, 23, 22, 9, 42, 8, 10, 5,
      29, 30, 31, 32, 0, 33, 34, 35, 36, 37, 38, 11, 12, 13, 14, 39, 16, 21, 6,
      4, 7, 41, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58,
      59, 60, 61, 63,
    ];
    return data.map((item, index) => {
      let display = "";
      if (!item.show) display = "none";
      return (
        <tr key={index} style={{ display: isModal ? "" : display }}>
          <td style={{ verticalAlign: "middle", width: "500px" }}>
            {item.title}
          </td>
          <td
            style={{ width: "200px" }}
            className="text-center"
            style={{ verticalAlign: "middle" }}
          >
            {isModal ? (
              <Checkbox
                onChange={this.onReportClick.bind(
                  this,
                  data,
                  index,
                  item.show ? false : true
                )}
                checked={item.show}
                checkboxClass="icheckbox_square-blue"
                increaseArea="20%"
                label=""
              />
            ) : (
              <Button
                style={{
                  backgroundColor:
                    success.indexOf(item.key) !== -1 ? "" : "#ddd",
                }}
                onClick={this.onViewPoClick.bind(this, item)}
              >
                <FontAwesome name="eye" />
                &nbsp;เรียกดู
              </Button>
            )}
          </td>
        </tr>
      );
    });
  }

  renderTable(
    key,
    title,
    data,
    iconName = "",
    bg = "",
    isModal = false,
    reportField
  ) {
    let { checkAll } = this.state;
    let { mode } = this.props;
    let checkDisplay = data.findIndex((x) => x.show === true);
    return (
      <div
        ref={(div) => {
          this._box[key] = div;
        }}
        style={{
          display:
            mode === "stock" ? (key === 3 || key === 4 ? "" : "none") : "",
          border: isModal
            ? "1px solid #ddd"
            : checkDisplay !== -1
            ? "1px solid #ddd"
            : "none",
          marginBottom: "10px",
        }}
      >
        <table
          className="table table-report-category"
          style={{ marginBottom: "0" }}
        >
          <thead>
            <tr
              style={{
                display: isModal ? "" : checkDisplay !== -1 ? "" : "none",
              }}
            >
              <th
                colSpan={isModal ? 1 : 2}
                style={{
                  verticalAlign: "middle",
                  backgroundColor: bg,
                  color: "#fff",
                }}
              >
                {iconName !== "" ? (
                  <FontAwesome name={iconName}></FontAwesome>
                ) : (
                  ""
                )}{" "}
                {title}
              </th>
              {isModal ? (
                <th
                  className="text-center"
                  style={{
                    width: "120px",
                    verticalAlign: "middle",
                    backgroundColor: bg,
                    color: "#fff",
                  }}
                >
                  <Checkbox
                    onChange={this.onReportAllClick.bind(
                      this,
                      data,
                      reportField,
                      checkAll[reportField] ? false : true
                    )}
                    checked={checkAll[reportField]}
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label=""
                  />
                </th>
              ) : (
                ""
              )}
            </tr>
          </thead>
          <tbody>{this.renderRowData(data, isModal)}</tbody>
        </table>
      </div>
    );
  }

  renderRow() {
    let {
      workReportCategory,
      stockReportCategory,
      financeReportCategory,
      poReportCategory,
      dataAnalysisReportCategory,
      hrReportCategory,
      materialColorReportCategory,
      employeeReportCategory,
      statisticsSummaryReportCategory,
    } = this.state;
    return (
      <div>
        <div
          className="col-xs-12 col-md-6 box-report-category"
          style={{ paddingLeft: "0" }}
        >
          {this.renderTable(
            0,
            "รายงานพนักงานและช่าง",
            employeeReportCategory,
            "users",
            "purple",
            false,
            "employeeReportCategory"
          )}
          {this.renderTable(
            2,
            "รายงานงานซ่อม",
            workReportCategory,
            "wrench",
            "orange",
            false,
            "workReportCategory"
          )}
          {this.renderTable(
            4,
            "รายงานคลัง",
            stockReportCategory,
            "industry",
            "black",
            false,
            "stockReportCategory"
          )}
          {this.renderTable(
            7,
            "รายงานฝ่ายบุคคล",
            hrReportCategory,
            "user",
            "gray",
            false,
            "hrReportCategory"
          )}
          {this.renderTable(
            8,
            "รายงานสรุปสถิติ",
            statisticsSummaryReportCategory,
            "line-chart",
            "cornflowerblue",
            false,
            "statisticsSummaryReportCategory"
          )}
        </div>
        <div
          className="col-xs-12 col-md-6 box-report-category"
          style={{ paddingRight: "0" }}
        >
          {this.renderTable(
            1,
            "รายงานวิเคราะห์ข้อมูล",
            dataAnalysisReportCategory,
            "line-chart",
            "red",
            false,
            "dataAnalysisReportCategory"
          )}
          {this.renderTable(
            3,
            "การใช้วัสดุสิ้นเปลืองและสี",
            materialColorReportCategory,
            "cubes",
            "black",
            false,
            "materialColorReportCategory"
          )}
          {this.renderTable(
            5,
            "รายงานการเงิน",
            financeReportCategory,
            "money",
            "green",
            false,
            "financeReportCategory"
          )}
          {this.renderTable(
            6,
            "รายงานสั่งซื้อ (PO)",
            poReportCategory,
            "shopping-cart",
            "orange",
            false,
            "poReportCategory"
          )}
        </div>
      </div>
    );
  }

  renderMenu(isSubMenu = false, subMenu = []) {
    let { eventKey, subEventKey } = this.state;
    let { showAdminMenu } = this.props;
    let menu = [];
    switch (eventKey) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 33:
        menu = employeeReportCategory;
        break;
      case 4:
      case 5:
      case 6:
      case 7:
      case 32:
      case 43:
      case 57:
      case 58:
      case 59:
      case 60:
      case 63:
        menu = dataAnalysisReportCategory;
        break;
      case 42:
      case 8:
      case 9:
      case 10:
      case 29:
        menu = workReportCategory;
        break;
      case 11:
      case 12:
      case 13:
      case 14:
      case 39:
      case 52:
        menu = materialColorReportCategory;
        break;
      case 15:
      case 16:
      case 17:
      case 18:
      case 19:
      case 21:
      case 31:
      case 34:
      case 50:
      case 51:
      case 53:
      case 54:
      case 61:
        menu = stockReportCategory;
        break;
      case 22:
      case 23:
      case 30:
      case 41:
      case 55:
      case 56:
        menu = financeReportCategory;
        break;
      case 24:
      case 25:
      case 26:
      case 20:
      case 40:
      case 27:
      case 28:
      case 100:
      case 101:
        menu = poReportCategory;
        break;
      case 35:
      case 36:
      case 37:
      case 38:
        menu = hrReportCategory;
        break;
      case 44:
      case 45:
      case 46:
      case 47:
      case 48:
      case 49:
        menu = statisticsSummaryReportCategory;
        break;
      default:
        break;
    }
    return (
      <div>
        <Breadcrumb>
          <Breadcrumb.Item
            active={eventKey === undefined ? true : false}
            href="javascript:void(0)"
            onClick={this.onRootMenuClick.bind(this)}
          >
            <FontAwesome name="file-text-o" /> รายงาน
          </Breadcrumb.Item>
          {eventKey != undefined ? this.renderTitleMenu() : ""}
          {menu.map((item, index) =>
            eventKey === item.key ? (
              <Breadcrumb.Item
                active={
                  eventKey === item.key && subEventKey === undefined
                    ? true
                    : false
                }
                key={index}
                href="javascript:void(0)"
                onClick={this.onMenuClick.bind(this, item)}
              >
                {item.title}
              </Breadcrumb.Item>
            ) : (
              ""
            )
          )}
          {isSubMenu ? this.renderSubMenu(subMenu) : ""}
          {showAdminMenu ? (
            <Breadcrumb.Item
              className="pull-right"
              onClick={this.onSettingOpen.bind(this)}
            >
              <FontAwesome name="gear" />
            </Breadcrumb.Item>
          ) : (
            ""
          )}
        </Breadcrumb>
        <input type="hidden" ref="focus" />
      </div>
    );
  }

  renderTitleMenu() {
    let { titleMenu, titleIcon, titleKey } = this.state;
    return (
      <Breadcrumb.Item
        active={false}
        href="javascript:void(0)"
        onClick={this.onSubRootMenuClick.bind(this, titleKey)}
      >
        <FontAwesome name={titleIcon} /> {titleMenu}
      </Breadcrumb.Item>
    );
  }

  renderSubMenu(subMenu) {
    let { subEventKey } = this.state;
    return subMenu.map((item, index) => {
      return (
        <Breadcrumb.Item
          active={subEventKey === item.key ? true : false}
          key={"s" + index}
          href="javascript:void(0)"
          onClick={() => {
            this.setState({ subEventKey: item.key });
          }}
        >
          {item.title}
        </Breadcrumb.Item>
      );
    });
  }

  renderBox() {
    return <div></div>;
  }

  renderReport() {
    let { eventKey } = this.state;
    return (
      <div style={{ display: eventKey != undefined ? "" : "none" }}>
        <div style={{ display: eventKey === 0 ? "" : "none" }}>
          <ReportWorking
            ref="reportWorkingOffice"
            type="office"
            show={eventKey === 0}
            renderMenu={this.renderMenu.bind(this)}
            onUpdateEventKey={this.onUpdateEventKey.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 1 ? "" : "none" }}>
          {this.renderBox()}
        </div>
        <div style={{ display: eventKey === 2 ? "" : "none" }}>
          <ReportCommissionMechanic
            show={eventKey === 2}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 3 ? "" : "none" }}>
          {this.renderBox()}
        </div>
        <div style={{ display: eventKey === 4 ? "" : "none" }}>
          <ReportQuotationMovement
            show={eventKey === 4}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 5 ? "" : "none" }}>
          <ReportSummaryWork
            ref="reportSummaryWork"
            show={eventKey === 5}
            renderMenu={this.renderMenu.bind(this)}
            onUpdateEventKey={this.onUpdateEventKey.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 6 ? "" : "none" }}>
          <ReportJobCostSheet
            ref="reportJobCostSheet"
            show={eventKey === 6}
            renderMenu={this.renderMenu.bind(this)}
            onUpdateEventKey={this.onUpdateEventKey.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 7 ? "" : "none" }}>
          <ReportOutstandingIncomeSummary
            ref="reportOutstandingIncomeSummary"
            show={eventKey === 7}
            renderMenu={this.renderMenu.bind(this)}
            onUpdateEventKey={this.onUpdateEventKey.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 42 ? "" : "none" }}>
          <ReportSummaryFixingWork
            show={eventKey === 42}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 8 ? "" : "none" }}>
          <ReportUnfinishedWork
            ref="reportUnfinishedWork"
            show={eventKey === 8}
            renderMenu={this.renderMenu.bind(this)}
            onUpdateEventKey={this.onUpdateEventKey.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 9 ? "" : "none" }}>
          <ReportFixingRefixed
            show={eventKey === 9}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 10 ? "" : "none" }}>
          <ReportPostponeAppointment
            show={eventKey === 10}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 11 ? "" : "none" }}>
          <ReportConsumablesMaterial
            show={eventKey === 11}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 12 ? "" : "none" }}>
          <ReportColor
            ref="reportColor"
            show={eventKey === 12}
            renderMenu={this.renderMenu.bind(this)}
            onUpdateEventKey={this.onUpdateEventKey.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 13 ? "" : "none" }}>
          <ReportBalanceMaterial
            show={eventKey === 13}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 14 ? "" : "none" }}>
          <ReportStockMixPaint
            show={eventKey === 14}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 15 ? "" : "none" }}>
          <ReportProductBalance
            show={eventKey === 15}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 16 ? "" : "none" }}>
          <ReportProductTransactionRequestPurchase
            show={eventKey === 16}
            type="po"
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 17 ? "" : "none" }}>
          {this.renderBox()}
        </div>
        <div style={{ display: eventKey === 18 ? "" : "none" }}>
          <ReportProductTransactionImport
            show={eventKey === 18}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 19 ? "" : "none" }}>
          {this.renderBox()}
        </div>
        <div style={{ display: eventKey === 20 ? "" : "none" }}>
          <ReportPOReceivedProduct
            show={eventKey === 20}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 21 ? "" : "none" }}>
          <ReportProductTransactionRequestPurchase
            show={eventKey === 21}
            type="adjust"
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 22 ? "" : "none" }}>
          <ReportAccountReceiable
            ref="reportAccountReceiable"
            show={eventKey === 22}
            renderMenu={this.renderMenu.bind(this)}
            onUpdateEventKey={this.onUpdateEventKey.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 23 ? "" : "none" }}>
          <ReportSalesTax
            show={eventKey === 23}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 24 ? "" : "none" }}>
          <ReportKKCPurchaseOrderSummary
            show={eventKey === 24}
            credit="all"
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 41 ? "" : "none" }}>
          <ReportPostPayment
            show={eventKey === 41}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 25 ? "" : "none" }}>
          <ReportKKCPurchaseOrderSummary
            show={eventKey === 25}
            credit="45"
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 26 ? "" : "none" }}>
          <ReportKKCPurchaseOrderSummary
            show={eventKey === 26}
            credit="60"
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 27 ? "" : "none" }}>
          <ReportPOReceivedProduct
            show={eventKey === 27}
            type={"exportwork"}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 28 ? "" : "none" }}>
          <ReportPOReceivedProduct
            show={eventKey === 28}
            type={"return"}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 100 ? "" : "none" }}>
          <ReportPOReceivedProduct
            show={eventKey === 100}
            type={"import_stock"}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 101 ? "" : "none" }}>
          <ReportPOStock
            show={eventKey === 101}
            type={"import_stock"}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 29 ? "" : "none" }}>
          <ReportWaitingQuotation
            show={eventKey === 29}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 30 ? "" : "none" }}>
          <ReportKKCAllYearProfit
            show={eventKey === 30}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 31 ? "" : "none" }}>
          <ReportProductTransactionRequestPurchase
            show={eventKey === 31}
            type="request"
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 32 ? "" : "none" }}>
          <ReportKKCIncome
            show={eventKey === 32}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 33 ? "" : "none" }}>
          <ReportWorking
            ref="reportWorkingMechanic"
            type="mechanic"
            show={eventKey === 33}
            renderMenu={this.renderMenu.bind(this)}
            onUpdateEventKey={this.onUpdateEventKey.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 34 ? "" : "none" }}>
          <ReportPickup
            ref="reportPickup"
            report="ReportCategoryPage"
            show={eventKey === 34}
            renderMenu={this.renderMenu.bind(this)}
            onUpdateEventKey={this.onUpdateEventKey.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 35 ? "" : "none" }}>
          <ReportSummarySlip
            report="ReportCategoryPage"
            show={eventKey === 35}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 36 ? "" : "none" }}>
          <ReportSummaryOT
            report="ReportCategoryPage"
            show={eventKey === 35}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 37 ? "" : "none" }}>
          <ReportSummaryNormalAbsence
            report="ReportCategoryPage"
            show={eventKey === 37}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 38 ? "" : "none" }}>
          <ReportSummaryDeductionAbsence
            report="ReportCategoryPage"
            show={eventKey === 37}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 39 ? "" : "none" }}>
          <ReportUsageVolumeTransactionRecord
            show={eventKey === 39}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 40 ? "" : "none" }}>
          <ReportPOReceivedProduct
            show={eventKey === 40}
            type={"purchaseorder_item_product"}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 43 ? "" : "none" }}>
          <ReportSummaryInsure
            show={eventKey === 43}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 44 ? "" : "none" }}>
          <ReportAnalysisBestJobcardProduct
            show={eventKey === 44}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 45 ? "" : "none" }}>
          <ReportAnalysisBestPurchaseProduct
            show={eventKey === 45}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 46 ? "" : "none" }}>
          <ReportAnalysisBestJobcardService
            show={eventKey === 46}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 47 ? "" : "none" }}>
          <ReportAnalysisBestJobcardBrand
            show={eventKey === 47}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 48 ? "" : "none" }}>
          <ReportAnalysisBestPoShop
            show={eventKey === 48}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 49 ? "" : "none" }}>
          <ReportAnalysisBestJobcardInsurer
            show={eventKey === 49}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 50 ? "" : "none" }}>
          <ReportStockBalanceValue
            show={eventKey === 50}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 51 ? "" : "none" }}>
          <ReportStockCard
            show={eventKey === 51}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 52 ? "" : "none" }}>
          <ReportStockCardVolume
            show={eventKey === 52}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 53 ? "" : "none" }}>
          <ReportStockCardCost
            show={eventKey === 53}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 54 ? "" : "none" }}>
          <ReportStockFixingCar
            show={eventKey === 54}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 55 ? "" : "none" }}>
          <ReportReceiptVoucherPage
            show={eventKey === 55}
            page="report"
            callOut={eventKey === 55 ? false : true}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 56 ? "" : "none" }}>
          <ReportPaymentVoucherPage
            show={eventKey === 56}
            page="report"
            callOut={true}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 57 ? "" : "none" }}>
          <ReportAnalysisClaimOfTheMonth
            show={eventKey === 57}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 58 ? "" : "none" }}>
          <ReportAnalysisInOutWork
            show={eventKey === 58}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 59 ? "" : "none" }}>
          <ReportAnalysisWorkCustomCost
            show={eventKey === 59}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 60 ? "" : "none" }}>
          <ReportAnalysisDeliveryEfficiency
            show={eventKey === 60}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 61 ? "" : "none" }}>
          <ReportStockListInOut
            show={eventKey === 61}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
        <div style={{ display: eventKey === 63 ? "" : "none" }}>
          <ReportAnalysisWorkDebitCreditInOut
            show={eventKey === 63}
            renderMenu={this.renderMenu.bind(this)}
          />
        </div>
      </div>
    );
  }

  renderSettingRowDataModal() {
    let {
      checkWorkReportCategory,
      checkStockReportCategory,
      checkFinanceReportCategory,
      checkPoReportCategory,
      checkDataAnalysisReportCategory,
      checkHrReportCategory,
      checkMaterialColorReportCategory,
      checkEmployeeReportCategory,
      checkStatisticsSummaryReportCategory,
    } = this.state;
    return (
      <div className="row">
        <div className="col-xs-12 col-md-6 box-report-category">
          {this.renderTable(
            0,
            "รายงานพนักงานและช่าง",
            checkEmployeeReportCategory,
            "users",
            "purple",
            true,
            "employeeReportCategory"
          )}
          {this.renderTable(
            2,
            "รายงานงานซ่อม",
            checkWorkReportCategory,
            "wrench",
            "orange",
            true,
            "workReportCategory"
          )}
          {this.renderTable(
            4,
            "รายงานคลัง",
            checkStockReportCategory,
            "industry",
            "black",
            true,
            "stockReportCategory"
          )}
          {this.renderTable(
            7,
            "รายงานฝ่ายบุคคล",
            checkHrReportCategory,
            "user",
            "gray",
            true,
            "hrReportCategory"
          )}
          {this.renderTable(
            8,
            "รายงานสรุปสถิติ",
            checkStatisticsSummaryReportCategory,
            "line-chart",
            "cornflowerblue",
            true,
            "statisticsSummaryReportCategory"
          )}
        </div>
        <div className="col-xs-12 col-md-6 box-report-category">
          {this.renderTable(
            1,
            "รายงานวิเคราะห์ข้อมูล",
            checkDataAnalysisReportCategory,
            "line-chart",
            "red",
            true,
            "dataAnalysisReportCategory"
          )}
          {this.renderTable(
            3,
            "การใช้วัสดุสิ้นเปลืองและสี",
            checkMaterialColorReportCategory,
            "cubes",
            "black",
            true,
            "materialColorReportCategory"
          )}
          {this.renderTable(
            5,
            "รายงานการเงิน",
            checkFinanceReportCategory,
            "money",
            "green",
            true,
            "financeReportCategory"
          )}
          {this.renderTable(
            6,
            "รายงานสั่งซื้อ (PO)",
            checkPoReportCategory,
            "shopping-cart",
            "orange",
            true,
            "poReportCategory"
          )}
        </div>
      </div>
    );
  }

  renderSettingModal() {
    let { show, role, roles, loading } = this.state;
    let default_role = [{ label: "ทั้งองค์กร", value: "" }];
    let all_roles = default_role.concat(roles);
    return (
      <Modal
        show={show}
        enforceFocus={false}
        onHide={this.onHide.bind(this)}
        dialogClassName="midwidth-dialog"
      >
        <Modal.Header closeButton>
          <Modal.Title>ตั้งค่ารายแสดง/ซ่อนรายงาน</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Box loading={loading}>
            <Box.Body>
              <div style={{ marginBottom: "5px" }}>
                <Form inline>
                  <FormGroup>
                    <Select
                      style={{ width: "180px" }}
                      clearable={false}
                      value={role}
                      options={all_roles}
                      placeholder="--- เลือกรายการ ---"
                      onChange={this.onRoleChange.bind(this)}
                    />
                  </FormGroup>
                </Form>
              </div>
              {this.renderSettingRowDataModal()}
            </Box.Body>
          </Box>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="primary" onClick={this.onSaveClick.bind(this)}>
            <FontAwesome name="save" /> บันทึก
          </Button>
          <Button onClick={this.onHide.bind(this)}>
            <FontAwesome name="close" /> ปิด
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    let { loading, eventKey } = this.state;
    return (
      <div>
        <div style={{ display: eventKey === undefined ? "" : "none" }}>
          <Box loading={loading}>
            <Box.Header border={true}>{this.renderMenu(this)}</Box.Header>
            <Box.Body>{this.renderRow()}</Box.Body>
          </Box>
        </div>
        {this.renderReport()}
        {this.renderSettingModal()}
        <NotificationSystem ref="notificationSystem" />
      </div>
    );
  }
}

ReportCategoryPage.defaultProps = {
  displaySetting: [
    { key: 0, show: true },
    { key: 1, show: true },
    { key: 2, show: true },
    { key: 3, show: true },
    { key: 4, show: true },
    { key: 5, show: true },
    { key: 6, show: true },
    { key: 7, show: true },
    { key: 8, show: true },
  ],
  showAdminMenu: false,
  mode: "report",
};

export default ReportCategoryPage;



// WEBPACK FOOTER //
// ./src/view/report/ReportCategoryPage.js